// global feature flags
module.exports = {
  NEW_PERSONAL_COUNTER: {
    flag: 'eng-new-personal-counter',
    enabled: 'tree-based',
    disabled: 'default',
  },
  MAIN_FOOTER_FAQ_CARDS: {
    flag: 'jo-main-footer-faqs-cards',
    enabled: 'enabled',
    disabled: 'default',
  },
  PRIVACY_PROXY: {
    flag: 'sea-privacy-proxy',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  PRIVACY_PROXY_MS: {
    flag: 'sea-privacy-proxy-ms',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
};
